import actions from './actions';

const initState = { logs: null };

export default function logReducer(state = initState, action) {
  switch (action.type) {
    case actions.LOG_FIELDS_SUCCESS:
      return {
        ...state,
        fields: action.fields,
      };
    case actions.LOG_SUCCESS:
      return { ...state, logs: action.logs };
    case actions.LOG_ERROR:
      return { ...state, logError: action.logError };
    default:
      return state;
  }
}
